import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, tap} from 'rxjs';
import {environment} from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';

export class semaphores{
  questionaryId?:String;
  value_1?: String;
  value_2?: String;
  color?: String;
}

@Injectable({
  providedIn: 'root'
})
export class SemaphoresService {
  private apiURL = environment.api_cuestionarios_rest;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  
  constructor(
    private cookieService: CookieService,
    private http: HttpClient
  ) {
  }

  public postSemaphore(semaphore) :Observable<any>{
    const cues: semaphores = {
      questionaryId: semaphore.questionaryId,
      value_1: semaphore.min,
      value_2: semaphore.max,
      color: semaphore.color
    }
    const body = JSON.stringify(cues);
    const apiURL = this.apiURL+"semaphores";
    return this.http.post(`${apiURL}`, body, { headers: this.headers }).pipe(
    );
  }
  public updateSemaphore(semaphore){
    const cues: semaphores = {
      value_1: semaphore.min,
      value_2: semaphore.max,
      color: semaphore.color
    }
    const body = JSON.stringify(cues);
    const apiURL = this.apiURL+"semaphores/"+semaphore.id;
    return this.http.patch(`${apiURL}`,body, {headers: this.headers});
  }
  public deleteSemaphore(id: string) {
    const apiURL = this.apiURL+"semaphores/"+id;
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }
}
